import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import PagesList, { preloadPagesList } from '../components/pages-list';

interface PagesListProcessorElement extends Element {
  props: Element['props'] & {
    type?: string;
    template?: string;
    customFiltersByGroups?: Record<string, string[]>;
    mainGroupAlias?: string;
    mainGroupId?: string;
    showFilterForTheMainGroup?: boolean;
    limit?: string;
    loadMoreBtnText?: string;
    showLoadMoreBtn?: boolean;
    titleTag?: string;
    'data-erom-pages-type'?: string;
    'data-erom-pages-template'?: string;
    'data-erom-pages-limit'?: string;
    'data-erom-pages-load-more-btn-text'?: string;
    'data-erom-pages-custom-filters'?: string;
    'data-erom-pages-main-group-alias'?: string;
    'data-erom-pages-main-group-id'?: string;
    'data-erom-pages-show-filter'?: string;
    'data-erom-pages-show-load-more-btn'?: string;
    'data-erom-pages-title-tag'?: string;
  };
}

const pagesList: Processor<PagesListProcessorElement> = {
  priority: 10,
  name: 'pagesList',
  test: ({ node }) => !!node.props?.className?.includes('wp-block-erom-pages-list-rows'),
  processor: ({ node }) => {
    node.props.type = node.props['data-erom-pages-type'];
    node.props.template = node.props['data-erom-pages-template'];
    node.props.limit = node.props['data-erom-pages-limit'];
    node.props.loadMoreBtnText = node.props['data-erom-pages-load-more-btn-text'];
    node.props.mainGroupAlias = node.props['data-erom-pages-main-group-alias'];
    node.props.mainGroupId = node.props['data-erom-pages-main-group-id'];
    node.props.showFilterForTheMainGroup = node.props['data-erom-pages-show-filter'] === 'true';
    node.props.showLoadMoreBtn = node.props['data-erom-pages-show-load-more-btn'] === 'true';
    node.props.titleTag = node.props['data-erom-pages-title-tag'] || 'h2';

    try {
      node.props.customFiltersByGroups = structuredClone(
        JSON.parse(decodeURIComponent(node.props['data-erom-pages-custom-filters'] || '{}'))
      );
    } catch (e) {
      console.error('Failed to parse custom filters by groups for pages list block', e);
    }

    // Preload both categories and pages data into SWR cache
    preloadPagesList(
      node.props.mainGroupId,
      node.props.type,
      node.props.customFiltersByGroups,
      node.props.limit ? parseInt(node.props.limit, 10) : undefined
    );

    node.component = PagesList as ComponentType;

    return node;
  }
};

export default pagesList;
